import type { ReactElement, ReactNode } from "react";
import { ArrowLeft } from "lucide-react";
import { space } from "@tokens/index";
import { IconButton } from "../../primitives";

/**
 * Header of a detail panel: 16px gutters, title block leading, actions
 * trailing as one group. On `compact` the board passes `onBackToRail` and
 * the header leads with a back control that clears the selection. When
 * `actionsInline` is false the actions wrap to a row under the title.
 */
export function PanelHeader({
  onBackToRail,
  title,
  actions,
  actionsInline,
  children,
}: {
  readonly onBackToRail: (() => void) | undefined;
  readonly title: ReactNode;
  readonly actions?: ReactNode;
  readonly actionsInline: boolean;
  readonly children?: ReactNode;
}): ReactElement {
  return (
    <div
      data-testid="panel-header"
      style={{
        flexShrink: 0,
        display: "flex",
        flexDirection: "column",
        gap: space[2],
        padding: `${space[3]} ${space[4]}`,
        minWidth: 0,
      }}
    >
      <div
        style={{
          display: "flex",
          alignItems: "flex-start",
          gap: space[3],
          minWidth: 0,
        }}
      >
        {onBackToRail !== undefined && (
          <IconButton icon={ArrowLeft} variant="ghost" size="md" aria-label="Back to work items" onClick={onBackToRail} />
        )}
        <div style={{ flex: 1, minWidth: 0, display: "flex", flexDirection: "column", gap: space[2] }}>{title}</div>
        {actions !== undefined && actionsInline && (
          <div style={{ flexShrink: 0, minWidth: 0, display: "flex", justifyContent: "flex-end" }}>{actions}</div>
        )}
      </div>
      {actions !== undefined && !actionsInline && <div style={{ minWidth: 0 }}>{actions}</div>}
      {children}
    </div>
  );
}
